<template>
  <a-modal title="查看订单" :maskClosable="false" :width="1200" :visible="visible" :confirmLoading="confirmLoading"
    @cancel="handleCancel">
    <!-- :cancelText="'取消'"
    @ok="handleCancel" -->
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取消 </a-button>
    </template>
    <!-- <div class="content"> -->
    <a-row :gutter="22">
      <a-form layout="vertical" :form="form">
        <a-col :span="12">
          <!-- 订单编号 -->
          <a-form-item label="订单编号" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div>
              <span type="text">{{ finOrderItem.orderNo }}</span>
              <span v-if="finOrderItem.isCrossSchool == 1" class="cross">
                <img src="/crossSchool.png" style="width: 16px" alt="" />
                <em>跨校订单</em>
              </span>
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 支付单号 -->
          <a-form-item label="支付单号" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div>
              <span type="text">{{ finOrderItem.transId }}</span>
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 订单类型 -->
          <a-form-item label="订单类型" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">{{ finOrderItem.orderTypeText }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 班级学校 -->
          <a-form-item label="班级学校" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">{{ finOrderItem.classSchool }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 订单标题 -->
          <a-form-item label="订单标题" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">{{ finOrderItem.orderTitle }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 订单状态 -->
          <a-form-item label="订单状态" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">{{ finOrderItem.statusText }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="支付类型" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">
              {{
                finOrderItem.paymentMode == 0
                  ? '预付费'
                  : finOrderItem.paymentMode == 1
                    ? '后付费'
                    : ''
              }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 价格 -->
          <a-form-item label="价格/元" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">{{ finOrderItem.totalPrice / 100 }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 购买人姓名 -->
          <a-form-item label="购买人姓名" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">{{ finOrderItem.buyerName }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 学员学校 -->
          <a-form-item label="学员学校" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">{{ finOrderItem.studentSchool }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 动态显示    -------------课程方名称 -->
          <a-form-item label="课程方" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }"
            v-if="finOrderItem.institutionType">
            <div type="text">
              {{
                finOrderItem.institutionName
                  ? finOrderItem.institutionName
                  : '- -'
              }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item v-if="finOrderItem.institutionType" label="课程方种类" :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">
              {{
                finOrderItem.institutionTypeName
                  ? finOrderItem.institutionTypeName
                  : '- -'
              }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 动态显示 -------------------- 课程名称 -->
          <a-form-item label="课程名称" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">
              {{ finOrderItem.className ? finOrderItem.className : '- -' }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 创建时间 -->
          <a-form-item label="创建时间" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
            <div type="text">{{ finOrderItem.gmtCreate }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="支付信息" :labelCol="{ lg: { span: 6 } }" :wrapperCol="{ lg: { span: 18 } }">
          </a-form-item>
        </a-col>
      </a-form>
    </a-row>
    <a-table style="width: 100%" :columns="columns" :data-source="tableData" :pagination="false">
      <span slot="支付凭证" slot-scope="text,record">
        <a v-if="record.支付凭证" @click="show(record)">支付凭证</a>
      </span>
    </a-table>
    <!-- </div> -->
    <a-modal :maskClosable="false" :visible="previewVisible" :footer="null" @cancel="previewVisible = false" :width="550">
      <div class="pic">
        <a :href="previewImage" target="_blank"><img alt="example" :src="previewImage" /></a>
      </div>
      <div class="order-info">
        <div>
          支付单号：
          <a-input placeholder="请输入" v-model="receiptionInfo.orderNo" class="w200" :allowClear="true"
            @change="$forceUpdate()"></a-input>
        </div>
        <div>
          支付金额：
          <a-input-number placeholder="请输入" v-model="receiptionInfo.acount" class="w200" :min="0" :precision="2"
            @change="$forceUpdate()" />
        </div>
        <div>
          支付时间：
          <a-date-picker placeholder="请选择" :showTime="true" v-model="receiptionInfo.date" class="w200"
            @change="$forceUpdate()" />
        </div>
      </div>
      <div class="btns">
        <a-button @click="handleBtn(1)" style="margin-right: 24px;">设置为未支付</a-button>
        <a-button type="primary" @click="handleBtn(2)">设置为已支付</a-button>
      </div>
    </a-modal>
  </a-modal>
</template>

<script>
import dayjs from 'dayjs'
import order from '@/api/finOrder'
export default {
  name: 'finOrderFormModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      classroomId: '',
      updateData: {},
      finOrderItem: {}, //展示订单详情的容器
      previewImage: '',
      previewVisible: false,
      receiptionInfo: {},
      columns: [
        {
          title: '收付对象',
          width: 70,
          dataIndex: '收付对象',
        },
        {
          title: '收付类型',
          width: 70,
          dataIndex: '收付类型',
        },
        {
          title: '支付单号',
          dataIndex: '支付单号',
        },
        {
          title: '金额',
          width: 50,
          dataIndex: '金额',
        },
        {
          title: '状态',
          width: 70,
          dataIndex: '状态',
        },
        {
          title: '完成时间',
          dataIndex: 'CompleteTime',
        },
        {
          title: '关联信息',
          dataIndex: '关联信息',
        },
        {
          title: '操作',
          dataIndex: '支付凭证',
          scopedSlots: { customRender: "支付凭证" }
        },
      ],
      tableData: [],
    }
  },
  methods: {
    //初始化，显示
    init(type, params) {
      this.visible = true
      this.isAdd = type === 'add' ? true : false
      //初始化form表单数据
      if (params) {
        this.updateData = params
        this.finOrderItem = params
        this.tableData = params.payments
        console.log('this.finOrderItem', this.finOrderItem)
      } else {
        this.form.resetFields()
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.$emit('closeForm')
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, value) => {
        //校验通过
        if (!err) {
          if (this.isAdd) {
            this.addClassroom(value)
          } else {
            this.updateClassroom(value)
          }
        }
      })
    },
    show(e) {
      this.previewImage = e.支付凭证;
      this.previewVisible = true;
      this.receiptionInfo = {
        id: e.id
      }
      order.getPayment(e.id).then((res) => {
        this.receiptionInfo.orderNo = res.data.thirdpartyOrderNumber
        this.receiptionInfo.acount = res.data.finalAmount
        this.receiptionInfo.date = res.data.thirdpartyCallbackTime || res.data.created
        this.$forceUpdate()
      })
    },
    handleBtn(type) {
      let params = {}
      if (type == 1) {
        params = {
          id: this.receiptionInfo.id,
          status: 0
        }
      } else {
        if (!this.receiptionInfo.orderNo || !this.receiptionInfo.acount || !this.receiptionInfo.date) {
          return this.$message.error('请完善支付信息')
        }
        params = {
          id: this.receiptionInfo.id,
          amount: this.receiptionInfo.acount,
          payTime: dayjs(this.receiptionInfo.date).format('YYYY-MM-DD HH:mm:ss'),
          paymentOrderNo: this.receiptionInfo.orderNo,
          status: 1
        }
      }
      order.confirmBankTransfers(params).then(res => {
        this.$message.success('设置成功')
        if (res.data.transId) {
          this.finOrderItem.transId = res.data.transId
        } else {
          this.finOrderItem.transId = ''
        }
        this.finOrderItem.statusText = res.data.statusText
        this.previewVisible = false
        this.getOrder()
      })
    },
    getOrder(){
      order.getOrderPayment(this.finOrderItem.id).then(res => {
        this.tableData = res.data
      })
    }
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.ant-form-item {
  margin-bottom: 5px;
}

.cross {
  margin-left: 5px;
  color: #d71616 !important;

  em {
    border: 1.5px solid #d71616;
    border-radius: 4px;
    margin-left: 2px;
    font-style: normal;
  }
}

.content {
  height: calc(100vh - 280px);
  overflow-y: auto;
}

.pic {
  text-align: center;
  img {
    max-width: 500px !important;
    height: 500px !important;
  }
}

.w200 {
  width: 200px;
}

.order-info {
  margin: 20px 0;

  div {
    margin-bottom: 10px;
  }
}

.btns {
  text-align: center;
}

.ant-input-number {
  height: 32px;
  margin: 0 !important;
}
</style>
